import React from 'react';
import { func, node, string } from 'prop-types';
import classNames from 'classnames';
import { LuMessageCircle } from 'react-icons/lu';

import css from './ContactButton.css';

// The listing page's Contact button: DS Button "primary" with the message icon.
const ContactButton = props => {
  const { className, onClick, children } = props;
  return (
    <button type="button" className={classNames(css.root, className)} onClick={onClick}>
      <LuMessageCircle className={css.icon} aria-hidden="true" />
      {children}
    </button>
  );
};

ContactButton.defaultProps = {
  className: null,
};

ContactButton.propTypes = {
  className: string,
  onClick: func.isRequired,
  children: node.isRequired,
};

export default ContactButton;
